import { render, staticRenderFns } from "./hospitalLogs.vue?vue&type=template&id=786df39e&scoped=true"
import script from "./hospitalLogs.vue?vue&type=script&lang=js"
export * from "./hospitalLogs.vue?vue&type=script&lang=js"
import style0 from "./hospitalLogs.vue?vue&type=style&index=0&id=786df39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786df39e",
  null
  
)

export default component.exports